import SkeletonButton from './button';
import SkeletonNode from './node';
const Skeleton = props => {
  const {
    prefixClass = 'zen-design',
    //TODO 写provider时统一改掉
    className,
    style
  } = props;
  const baseClassName = "".concat(prefixClass, "-listEmpty");
  return null;
};
Skeleton.Button = SkeletonButton;
Skeleton.Node = SkeletonNode;
export default Skeleton;